import React from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { StatefullTextField } from "../../../common";
import { getValidationErrorMessage } from "../../../../utils/validations/validations";
// eslint-disable-next-line import/no-cycle
import { FieldTitle } from "..";

function StringField({
  itemData,
  classes,
  id,
  fieldName,
  error,
  disabled,
  config,
  updateItem,
  updateItemValidationError,
  validLength,
  onCustomizeValue,
}) {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  return (
    <div className={classes.rowContainer}>
      <FieldTitle
        title={t(`caseItemFields.${fieldName}.title`)}
        optional={config.optional}
      />
      <div className={classes.controlContainer}>
        <StatefullTextField
          error={!!error}
          helperText={getValidationErrorMessage(error, t, { validLength })}
          className={classes.stringField}
          initialValue={itemData[fieldName] || ""}
          variant="outlined"
          placeholder={t(`caseItemFields.${fieldName}.placeholder`)}
          margin="dense"
          disabled={disabled}
          onChange={newValue => {
            dispatch(
              updateItemValidationError(itemData.uuid, { [fieldName]: "" })
            );
            dispatch(
              updateItem({
                ...itemData,
                [fieldName]: newValue,
              })
            );
          }}
          id={`${id}-${fieldName}`}
          onCustomizeValue={onCustomizeValue}
        />
      </div>
    </div>
  );
}

StringField.propTypes = {
  classes: PropTypes.shape({
    rowContainer: PropTypes.string,
    controlContainer: PropTypes.string,
    stringField: PropTypes.string,
  }),
  id: PropTypes.string,
  error: PropTypes.string,
  itemData: PropTypes.shape({
    uuid: PropTypes.string,
  }),
  disabled: PropTypes.bool,
  fieldName: PropTypes.string,
  config: PropTypes.shape({
    optional: PropTypes.bool,
  }),
  updateItem: PropTypes.func,
  updateItemValidationError: PropTypes.func,
  validLength: PropTypes.number,
  onCustomizeValue: PropTypes.func,
};

StringField.defaultProps = {
  disabled: false,
  onCustomizeValue: null,
  classes: {},
  id: "",
  error: "",
  itemData: {},
  fieldName: "",
  config: {},
  updateItem: null,
  updateItemValidationError: null,
  validLength: 0,
};

export default StringField;
